import {Component, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {FilterPanelComponent} from '@app/assetfilter/filter-panel/filter-panel.component';
import {FilterPanelComponent as FilterPanelComponent_1} from '../filter-panel/filter-panel.component';

@Component({
    selector: 'frog-filter-dialog',
    templateUrl: './filter-dialog.component.html',
    styleUrls: ['./filter-dialog.component.scss'],
    imports: [MatDialogContent, FilterPanelComponent_1, MatDialogActions, MatButton],
})
export class FilterDialogComponent implements OnInit {
    @ViewChild(FilterPanelComponent) filterPanel;

    constructor(public dialogRef: MatDialogRef<FilterDialogComponent>) {}

    ngOnInit(): void {}

    apply() {
        this.filterPanel.apply();
        this.dialogRef.close();
    }

    clear() {
        this.filterPanel.clear();
        this.dialogRef.close();
    }
}
